import { Record, Map, List } from 'immutable'

const NoteActivityRecord = Record(
  {
    id: '',
    createdAt: 0,
    type: '',
    noteId: '',
    note: null,
    userIds: List(),
    metadata: Map(),
    thread: null,
  },
  'NoteActivityRecord'
)

export default NoteActivityRecord

export function createFromRaw(rawNoteActivity) {
  return new NoteActivityRecord(rawNoteActivity)
}
